import styled from 'styled-components';

export const QueryItemStyle = styled.li`
  box-shadow: 1px 1px 4px 1px rgba(0, 128, 0, 0.5);
  height: 40px;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 12px;
  border-radius: 2px;
  background-color: #f1f1f1;
  padding: 5px 9px 0px;
  vertical-align: center;
`

export const ListItem = styled.p`
  display: inline-block;
  cursor: default;
  padding-top: 3px;
  margin: 0px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #4a4a4a;
`

export const CloseButton = styled.button`
  display: inline-block;
  box-shadow: ${(props) => props.isHovered ? '1px 1px 6px 1px rgba(0, 128, 0, 1)' : 'grey'};
  background-color: Transparent;
  border: none;
  padding: 0px;
  margin: 0px 0px 0px 6px;
`
